var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMan = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 53.5 53.5",
    style: {
      enableBackground: "new 0 0 53.5 53.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 26.7,
    cy: 4.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.3,11.2c-1.1-0.2-2.3-0.2-3.4,0c-7.5,0.9-9.9,9.6-9.2,16.2c0.3,2.9,4.8,2.9,4.5,0c-0.3-2.4-0.1-6,1.1-8.6 c0,3.1,0,6.3,0,9.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.1c0,7.5,0,15-0.3,22.4c-0.1,3.3,5,3.3,5.1,0c0.2-5.9,0.3-11.7,0.3-17.6 c0.2,0,0.5,0,0.7,0c0,5.9,0.1,11.7,0.3,17.6c0.1,3.3,5.3,3.3,5.2,0c-0.3-7.5-0.3-14.9-0.3-22.4c0-0.2,0-0.4-0.1-0.6 c0-3.2-0.1-6.5-0.1-9.7c1.5,2.6,1.7,6.6,1.4,9.1c-0.3,2.9,4.2,2.9,4.5,0C38.7,20.6,36.1,11.7,28.3,11.2z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/man.d2b79ae9.svg";
export { ForwardRef as ReactComponent };